import { useTranslation } from "react-i18next";
import type { Me } from "@arc/contracts";
import type { TenantBootstrap } from "../../../tenant/bootstrap.js";

/** The legacy "Profil" page, read-only (ADR-032): who you are, how you sign in, which roles you hold. */
export function ProfilePage({ me, tenant }: { me: Me; tenant: TenantBootstrap }) {
  const { t } = useTranslation();
  return (
    <dl className="grid max-w-prose grid-cols-[max-content_1fr] gap-x-6 gap-y-2 text-sm">
      <dt className="text-muted-foreground">{t("workspace.name")}</dt>
      <dd className="m-0">{me.displayName}</dd>
      <dt className="text-muted-foreground">{t("workspace.email")}</dt>
      <dd className="m-0">{me.email ?? "—"}</dd>
      <dt className="text-muted-foreground">{t("workspace.organisation")}</dt>
      <dd className="m-0">{tenant.clientName}</dd>
      <dt className="text-muted-foreground">{t("workspace.roles")}</dt>
      <dd className="m-0">
        {me.roles.length === 0 ? (
          "—"
        ) : (
          <ul className="m-0 flex list-none flex-wrap gap-1.5 p-0">
            {me.roles.map((r) => (
              <li key={r} className="bg-muted text-muted-foreground rounded-full px-2 py-0.5 text-xs">
                {r}
              </li>
            ))}
          </ul>
        )}
      </dd>
    </dl>
  );
}
